import { ArrowLeftIcon } from '@/icons/ArrowLeftIcon';
import { ArrowRightIcon } from '@/icons/ArrowRightIcon';
import { cn } from '@pulsex/utils';
import React from 'react';

type NavControlProps = {
    setCurrent: any;
    position?: 'left' | 'right';
    length: number;
    color?: 'gray' | 'red';
    className?: string;
};

const NavControl = ({
    setCurrent,
    length,
    position = 'right',
    color = 'gray',
    className,
}: NavControlProps) => {
    const handlePrevious = () => {
        setCurrent((prev: number) => (prev === length - 1 ? 0 : prev + 1));
    };

    const handleNext = () => {
        setCurrent((prev: number) => (prev === 0 ? length - 1 : prev - 1));
    };

    return (
        <div
            onClick={position === 'right' ? handlePrevious : handleNext}
            className={cn(
                'p-2 select-none rounded-full absolute top-1/2 max-md:top-[45%] -translate-y-1/2 z-10 cursor-pointer',
                position === 'left' ? 'left-2' : 'right-2',
                className
            )}
        >
            <div
                className={cn(
                    ' p-2 rounded-full',
                    color === 'red'
                        ? 'bg-red-500/60 hover:bg-red-500/90'
                        : 'bg-gray-700/75 hover:bg-gray-700/90'
                )}
            >
                {position === 'right' ? (
                    <ArrowRightIcon
                        size={30}
                        className="fill-white drop-shadow-md max-md:w-5 max-md:h-5"
                    />
                ) : (
                    <ArrowLeftIcon
                        size={30}
                        className="fill-white drop-shadow-md max-md:w-5 max-md:h-5"
                    />
                )}
            </div>
        </div>
    );
};

export default NavControl;
